import { PURL_AGENT_DATA } from 'utilities/sessionStorageKeys';

import { get } from 'temp/utilities/storage';

const getAgentNpn = () => {
    const agentDetails = get(PURL_AGENT_DATA);
    const envAgentNpn = process?.env?.REACT_APP_AGENT_NPN?.toString()?.trim();
    if (agentDetails) {
        return Number(agentDetails.agentNpn);
    }
    if (envAgentNpn?.length) {
        return envAgentNpn;
    }
    return null;
};

export { getAgentNpn };
